import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

export default function TableSimpleCell({ columns, rows, clickFunc }) {
    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        {columns.map(col => (
                            <TableCell key={`col${col.id}`} sx={{textAlign:'center'}} >{col.label}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, rowIndex) => (
                        <TableRow
                            key={row.name}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer' }}
                        >
                            {columns.map(col => {
                                const format = col.format ? col.format : (txt) => txt;
                                const Component = col.component ? col.component : null;
                                const dataLine = row[col.id];
                                return(
                                    <TableCell 
                                        component="th" 
                                        scope="row" 
                                        onClick={() => clickFunc(dataLine, col.id, rowIndex)}
                                        sx={{':hover': {backgroundColor: 'rgba(0, 0, 0, 0.1)'}}}
                                    >
                                        {format(dataLine)}
                                        {Component && <Component item={dataLine} />}
                                    </TableCell>
                                );
                            })}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}